export const Guides = {
    "create-campaign": "https://rankerx.com/rankerx_guide/create-campaign",
    "strategy": "https://rankerx.com/rankerx_guide/diagrams",
    "content-groups": "https://rankerx.com/rankerx_guide/content-groups",
    "catchall-mail": "https://rankerx.com/rankerx_guide/catchall-mail",
    "email-manager": "https://rankerx.com/rankerx_guide/email-manager",
    "strategy-designer": "https://rankerx.com/rankerx_guide/strategy-designer",
    "wizard-post-without-links": "https://rankerx.com/rankerx_guide/wizard-post-without-links",
    "link-matching": "https://rankerx.com/rankerx_guide/link-matching",
    "how-to-upgrade": "https://rankerx.com/rankerx_guide/how-to-upgrade"
}